import { Box } from '@mui/material';
import { FC } from 'react';

import { AbgTypography } from '@abg/kit-base';

import { rateTermsNotesCommonStyling } from './rate-term-item.styling';
import { RateTermItemProps } from './rate-term-item.types';

export const RateTermItem: FC<RateTermItemProps> = ({ children }) => {
  return (
    <Box component="li">
      <AbgTypography
        variant={'bodySmallRegular'}
        sx={rateTermsNotesCommonStyling}
      >
        {children}
      </AbgTypography>
    </Box>
  );
};
